@let hotel = hotel$ | async;
<vp-availability-widget
	[accommodationTypes]="accommodationTypes()"
	[bookingtoolUrl]="bookingtoolUrl"
	[currency]="currency()"
	[dealGUID]="dealGUID()"
	[defaultAdults]="defaultAdults()"
	[forceHideRangePrices]="forceHideRangePrices()"
	[hotelGUID]="hotel?.GUID || hotelGUID()"
	[hotelSlug]="hotelSlug()"
	[hotels]="hotels()"
	[initialArrivalDate]="initialArrivalDate()"
	[initialOccupancy]="initialOccupancy()"
	[language]="language()"
	[maxDate]="maxDate()"
	[minDate]="minDate()"
	[occupancyRestrictions]="
		occupancyRestrictions() ||
		hotel?.occupancyRestrictions ||
		defaultOccupancyRestrictions
	"
	[openAvailabilityInNewTab]="openAvailabilityInNewTab()"
	[packageGUID]="packageGUID()"
	[packages]="packages()"
	[roomGUID]="roomGUID()"
	[showAccommodationTypes]="showAccommodationTypes()"
	[showDates]="showDates()"
	[showHotels]="showHotels()"
	[showOccupancy]="showOccupancy()"
	[showPackages]="showPackages()"
	[showPrices]="showPrices()"
	[stepperConfig]="stepperConfig()"
	[useCustomEmitter]="useCustomEmitter()"
	(actionClick)="widgetCTA($event)"
	(customEmitter)="customEmitter.emit($event)"
	(packageSelected)="packageSelected.emit($event)"
>
	<ng-content />
</vp-availability-widget>
